import { useEffect } from "react";
import { generateStaticPieNode } from "../../graph-util";
import { calculatePieChunks } from "../../utils";
import { CreateControlNodeOnlyFn, ItemWithClassification } from "../../@types";
import { NetworkRepEntry } from "../../../network/@types/Url";

interface Props {
  data: NetworkRepEntry[] | undefined;
  renderer: CreateControlNodeOnlyFn;
  counts: number;
}
const useRenderNetworkConnections = ({
  data: sandboxNetworkDataMerged,
  renderer: createControlNodeFromData,
  counts: totalCount
}: Props) => {
  useEffect(() => {
    if (!sandboxNetworkDataMerged) return;
    createControlNodeFromData({
      generateControlNode: () =>
        generateStaticPieNode({
          id: "networkConnectionsNode",
          label: "Network Connections",
          points: calculatePieChunks(
            sandboxNetworkDataMerged as ItemWithClassification[],
            (item: ItemWithClassification) => item.classification
          ),
          radius: 70,
          total: totalCount
        })
    });
  }, [createControlNodeFromData, sandboxNetworkDataMerged, totalCount]);
};

export default useRenderNetworkConnections;
